<template>
	<div class="brand-recommend">
		<form @submit.prevent="search">
			<ManagingSection :column-count="2">
				<ManagingBox title="추천 브랜드명">
					<input type="text" v-model="adminTitle" />
				</ManagingBox>
				<ManagingBox title="분류">
					<RadioList
						v-model="brandStatus"
						:radio-list="brandStatusList"
					/>
				</ManagingBox>
				<ManagingBox title="노출기간">
					<DateRange v-model="reservedPeriod" />
				</ManagingBox>
			</ManagingSection>
			<div class="btn-wrap-main">
				<button
					type="submit"
					class="btn-main blue"
					v-text="'검색하기'"
				/>
				<button
					type="button"
					class="btn-main blue bordered"
					v-text="'초기화'"
					@click="rewrite"
				/>
			</div>
		</form>
		<ManagingSection :is-table="true">
			<template slot="infoSection">
				<div class="section__info__left">
					<p class="brand-recommend__notice">
						등록 : {{ totalItem }}건 / 활성 : {{ displayNumber }}건
						/ 비활성 : {{ undisplayNumber }}건
						<span class="banner-manage-page__desc">
							- 추천 브랜드는 반드시
							<strong>2개 이상</strong> 등록해주세요.</span
						>
					</p>
				</div>
				<div class="section__info__right">
					<Selector
						:optionList="sortList"
						v-model="sort"
						@input="getList"
					/>
				</div>
			</template>
			<table class="table-main brand-recommend__table">
				<thead>
					<tr>
						<th>번호</th>
						<th>순서</th>
						<th>추천브랜드명</th>
						<th>브랜드</th>
						<th>타이틀</th>
						<th>디스크립션</th>
						<th>프로모션 이미지</th>
						<th>시작 일시</th>
						<th>종료 일시</th>
						<th>삭제</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in brandList" :key="item.id">
						<td class="brand-recommend__num">{{ item.id }}</td>
						<td class="brand-recommend__num">
							{{
								typeof item.sort === 'number' ? item.sort : '-'
							}}
						</td>
						<td class="brand-recommend__admin-title">
							<router-link
								:to="`/advertisement/brand-recommend-modify/${item.id}`"
								class="link"
								>{{ item.adminTitle || '-' }}</router-link
							>
						</td>
						<td class="brand-recommend__num">
							{{ item.brandTitle }}
						</td>
						<td class="brand-recommend__title">{{ item.title }}</td>
						<td class="brand-recommend__num">
							{{ item.description }}
						</td>
						<td class="brand-recommend__num">
							<ImageExif
								:src="item.imgUrl"
								v-if="item.imgUrl"
								@click.native="viewOriginImg(item.imgUrl)"
								class="brand-recommend__img"
							/>
						</td>
						<td class="brand-recommend__date">
							{{ item.startAt }}
						</td>
						<td class="brand-recommend__date">{{ item.endAt }}</td>
						<td class="brand-recommend__button">
							<button
								class="btn blue"
								@click="deleteList(item.id)"
							>
								삭제
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</ManagingSection>
		<PaginationBox
			slot="pagination"
			class="brand-recommend__pagination"
			:total-item="totalItem"
			:limit="limit"
			:offset="offset"
			@to="searchList($event.offset)"
		/>
	</div>
</template>
<script>
	import PaginationBox from '@/components/PaginationBox';
	import moment from 'moment';
	import ImageExif from '@/components/ImageExif.vue';
	import Util from '@/util';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import DateRange from '@/components/DateRange';
	import RadioList from '@/components/RadioList';
	import Selector from '@/components/Selector.vue';

	export default {
		name: 'BrandRecommendManage',
		data() {
			return {
				offset: 0,
				limit: 10,
				totalItem: 0,
				brandList: [],
				adminTitle: '',
				reservedPeriod: { from: '', to: '' },
				brandStatus: 0,
				brandStatusList: [
					{ id: 0, value: '전체' },
					{ id: 1, value: '노출' },
					{ id: 2, value: '미노출' },
				],
				sort: 3,
				sortList: [
					{ value: 1, name: '정렬순' },
					{ value: 2, name: '정렬역순' },
					{ value: 3, name: '최근등록순' },
					{ value: 4, name: '이전등록순' },
				],
				displayNumber: 0,
				undisplayNumber: 0,
			};
		},
		created() {
			this.setFilter();
			this.getList();
		},
		components: {
			PaginationBox,
			ImageExif,
			ManagingSection,
			ManagingBox,
			DateRange,
			RadioList,
			Selector,
		},
		methods: {
			searchList(offset = 0) {
				this.offset = offset;
				this.getList();
			},
			search() {
				this.offset = 0;
				this.getList();
			},
			setFilter() {
				const query = this.$route.query;
				if (query.sort) {
					this.sort = Number(query.sort);
				}
				if (query.limit) {
					this.limit = Number(query.limit);
				}
				if (query.offset) {
					this.offset = Number(query.offset);
				}
				if (query.adminTitle) {
					this.adminTitle = String(query.adminTitle);
				}
				if (query.startAt || query.endAt) {
					this.reservedPeriod.from = String(query.startAt) || '';
					this.reservedPeriod.to = String(query.endAt) || '';
				}
				if (query.status) {
					this.brandStatus = Number(query.status);
				}
			},
			setQuery() {
				const query = {
					sort: String(this.sort),
					limit: String(this.limit),
					offset: String(this.offset),
					status: String(this.brandStatus),
				};
				if (this.adminTitle) {
					query.adminTitle = String(this.adminTitle);
				}
				if (this.reservedPeriod.from || this.reservedPeriod.to) {
					query.startAt = this.reservedPeriod?.from;
					query.endAt = this.reservedPeriod?.to;
				}

				this.$router.replace({ query }).catch(() => {});
			},
			rewrite() {
				this.reservedPeriod.from = '';
				this.reservedPeriod.to = '';
				this.adminTitle = '';
				this.brandStatus = 0;
				this.limit = 20;
				this.offset = 0;
				this.getList();
			},
			async getList() {
				try {
					let status = null;
					switch (this.brandStatus) {
						case 0:
							status = '';
							break;
						case 1:
							status = true;
							break;
						case 2:
							status = false;
							break;
						default:
							break;
					}
					const params = {
						adminTitle: this.adminTitle,
						startAt:
							moment(this.reservedPeriod.from).valueOf() || '',
						endAt: moment(this.reservedPeriod.to).valueOf() || '',
						order: this.sort,
						isDisplay: status,
					};
					const { data } = await this.$axiosAdmin2.get(
						`/v3/api/brand/recommendModule/list?offset=${this.offset}&limit=${this.limit}`,
						{ params }
					);
					this.brandList = data.data.map(item => ({
						...item,
						startAt: moment
							.unix(item.startAt)
							.format('YYYY-MM-DD HH:mm'),
						endAt: moment
							.unix(item.endAt)
							.format('YYYY-MM-DD HH:mm'),
					}));
					this.totalItem = data.total;
					this.undisplayNumber = data.nonDisplay;
					this.displayNumber = data.display;
					this.setQuery();
				} catch (err) {
					console.error(err);
				}
			},
			async deleteList(id) {
				if (!confirm('정말 삭제하시겠습니까?')) return;
				try {
					await this.$axiosAdmin2.delete(
						`/v3/api/brand/recommendModule/${id}`
					);
					alert('삭제 되었습니다.');
					this.getList();
				} catch (err) {
					console.error(err);
					alert(
						'삭제 실패하였습니다. 지속적인 문제 발생시 개발팀에 문의바랍니다.'
					);
				}
			},
			viewOriginImg(imgPath) {
				const img = [imgPath];
				if (!imgPath) {
					alert(
						'이미지 불러오기에 실패하였습니다. 지속적인 문제 발생시 개발팀에 문의바랍니다.'
					);
				} else {
					Util.popupImages(img, 500, true);
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.brand-recommend {
		&__img {
			cursor: pointer;
			width: 200px;
			text-align: center;
			margin: 0 auto;
		}
		&__admin-title {
			max-width: 360px;
		}

		&__notice {
			margin-top: 20px;
			text-align: left;
			font-size: 15px;
		}

		&__pagination {
			margin-top: 30px;
		}
	}
</style>
